const l = {
  name: "Salad",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,7.1V2h-1C9.9,2,7.2,4,6.3,6.8C5.3,6.3,4.2,6,3,6H2v8H0v5c0,6.8,5.3,12.5,12,13v4h16v-4
			c6.7-0.5,12-6.1,12-13v-5h-2c0-3.8-2.6-7-6.2-7.8C31,2.6,27.8,0,24,0s-7,2.6-7.8,6.2C15.4,6.4,14.7,6.7,14,7.1z M24,2
			c3,0,5.6,2.3,5.9,5.2L30,8l0.8,0.1C33.7,8.4,36,11,36,14h-4.6l2.3-2.3l-1.4-1.4L28.6,14H25V5h-2v9h-2.6l-3.7-3.7l-1.4,1.4l2.3,2.3
			H12c0-3,2.3-5.6,5.2-5.9L18,8l0.1-0.8C18.4,4.3,21,2,24,2z M12,8.7c-1.2,1.4-2,3.3-2,5.3v-1c0-1.9-0.7-3.6-1.9-4.8
			c0.3-2,1.9-3.7,3.9-4.1V8.7z M2,16h36v3c0,6.1-4.9,11-11,11H13C6.9,30,2,25.1,2,19V16z M8,13v1H4V8.1C6.3,8.6,8,10.6,8,13z M26,32
			v2H14v-2H26z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Salad
};
